import useDefaultAppName from './useDefaultAppName';

export { useDefaultAppName };
